import { Dialog, ModalHeader, useOpenModal } from "@/components/modal";
import { formatNumber } from "@/shared/formats";
import { Divider, Link, LinkProps, Stack, Typography } from "@mui/material";
import { useId } from "react";
import { mapMonedaValues } from "../shared/utils";
import useMonetizacion from "../hooks/use-monetizacion";

export interface PrecioViewProps extends Omit<LinkProps<"span">, "children"> {
    monto?: number,
}

export default function PrecioView({
    monto,
    ...props
}: PrecioViewProps) {
    const name = "precio-view-modal-code-" + useId();

    const openModal = useOpenModal();
    const { monedaBase, monedas, cotizacion } = useMonetizacion();

    if (!monto) return <Typography {...props} component={"span"}>
        {monto == null ? formatNumber(monto) : `${formatNumber(monto)} ${monedaBase.simbolo}`}
    </Typography>

    return <>
        <Link noWrap {...props} sx={{ ...props.sx, minWidth: 0, cursor: "pointer" }} onClick={e => {
            props.onClick && props.onClick(e);
            if (!e.defaultPrevented) openModal(name)
        }} component={"span"}>
            {formatNumber(monto)} {monedaBase.simbolo}
        </Link>
        <Dialog code={name}>
            <ModalHeader>Cotización</ModalHeader>
            <Divider flexItem />
            <Stack flex={1} gap={2} padding={2} minWidth={"250px"}>
                {monedas.map(m => <Stack gap={5} key={m.id} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                    <Typography variant="subtitle1">{m.nombre}: </Typography>
                    <Typography>{formatNumber(mapMonedaValues(cotizacion, monto, monedaBase.id, m.id))} {m.simbolo}</Typography>
                </Stack>)}
            </Stack>
        </Dialog>
    </>
}